var STORAGE_KEY = "warranty_payment_gtm_data";
/** Write GTM context to localStorage before navigating to the payment page. */
export var storeWarrantyGtmData = function storeWarrantyGtmData(data) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (e) {
    console.error("[warrantyGtmStorage] Failed to store:", e);
  }
};

/**
 * Read and immediately clear GTM context from localStorage.
 * Call once on the success page — returns null if nothing was stored.
 */
export var getAndClearWarrantyGtmData = function getAndClearWarrantyGtmData() {
  try {
    var raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    localStorage.removeItem(STORAGE_KEY);
    return JSON.parse(raw);
  } catch (e) {
    console.error("[warrantyGtmStorage] Failed to read:", e);
    return null;
  }
};